import { useMutation, useQueryClient } from "react-query";
import { message } from "antd";
import { onDeleteDuplicate } from "../../../DuplicateData/services/postDeleteDataDuplicate";

export const useDeleteDuplicateMutation = (parentId, onSuccessCallback) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      await onDeleteDuplicate(data);
    },
    {
      onSuccess: () => {
        message.success("Data duplikat berhasil dihapus !");
        queryClient.invalidateQueries(["parentDetail", parentId]);
        if (onSuccessCallback) onSuccessCallback();
      },
      onError: () => {
        message.error("Data duplikat gagal dihapus !");
      },
    }
  );
};
